import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const warehouseService = {
  // Get all warehouses
  async getWarehouses() {
    return apiClient.get(`/api/cmms/warehouses?${getCompanyParam()}`);
  },

  // Get warehouses by branch
  async getWarehousesByBranch(branchId) {
    return apiClient.get(`/api/cmms/warehouses/branch/${branchId}?${getCompanyParam()}`);
  },

  // Get active warehouses only
  async getActiveWarehouses() {
    return apiClient.get(`/api/cmms/warehouses/active?${getCompanyParam()}`);
  },

  // Get single warehouse by ID
  async getWarehouseById(id) {
    return apiClient.get(`/api/cmms/warehouses/${id}?${getCompanyParam()}`);
  },

  // Create new warehouse
  async createWarehouse(data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      warehouseType: data.warehouseType,
      status: data.status || 'ACTIVE',
      description: data.description || null,
      capacity: data.capacity ? parseInt(data.capacity) : null,
      capacityUnit: data.capacityUnit || null,
      currentUtilization: data.currentUtilization ? parseInt(data.currentUtilization) : null,
      managerName: data.managerName || null,
      managerEmail: data.managerEmail || null,
      managerPhone: data.managerPhone || null,
      notes: data.notes || null
    };
    return apiClient.post(`/api/cmms/warehouses?${getCompanyParam()}`, payload);
  },

  // Update warehouse
  async updateWarehouse(id, data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      warehouseType: data.warehouseType,
      status: data.status || 'ACTIVE',
      description: data.description || null,
      capacity: data.capacity ? parseInt(data.capacity) : null,
      capacityUnit: data.capacityUnit || null,
      currentUtilization: data.currentUtilization ? parseInt(data.currentUtilization) : null,
      managerName: data.managerName || null,
      managerEmail: data.managerEmail || null,
      managerPhone: data.managerPhone || null,
      notes: data.notes || null
    };
    return apiClient.put(`/api/cmms/warehouses/${id}?${getCompanyParam()}`, payload);
  },

  // Delete warehouse
  async deleteWarehouse(id) {
    return apiClient.delete(`/api/cmms/warehouses/${id}?${getCompanyParam()}`);
  },
};
